// import MatejKralLogo from '@/public/logo-03.svg';

// import React from 'react';
function MKLogo({w,h}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={w}
      height={h}
      fill='none'
      viewBox='0 0 21 27'
    >
      <path
        stroke='color(display-p3 0.9373 0.8667 0.6235)'
        strokeWidth='1.235'
        d='M.618 5.548c0-.341.276-.618.617-.618h18.53c.34 0 .617.277.617.618v10.315c0 5.457-4.424 9.882-9.882 9.882-5.458 0-9.882-4.425-9.882-9.883V5.549z'
      ></path>
      <path
        fill='color(display-p3 0.9373 0.8667 0.6235)'
        fillRule='evenodd'
        d='M5.25.885V2.799c0 .273.221.494.494.494h9.45a.494.494 0 00.494-.494V.885a.247.247 0 00-.247-.248h-1.05a.247.247 0 00-.247.248v1.173h-2.903V.885a.247.247 0 00-.247-.248h-1.05a.247.247 0 00-.247.248v1.173H6.794V.885a.247.247 0 00-.247-.248h-1.05a.247.247 0 00-.247.248z'
        clipRule='evenodd'
      ></path>
      <mask
        id='mask0_250_242'
        style={{ maskType: 'alpha' }}
        width='17'
        height='21'
        x='2'
        y='4'
        maskUnits='userSpaceOnUse'
      >
        <path
          fill='color(display-p3 0.8510 0.8510 0.8510)'
          d='M2.162 5.61c0-.683.553-1.236 1.235-1.236h14.206c.682 0 1.235.553 1.235 1.236V15.8a8.338 8.338 0 01-16.676 0V5.61z'
        ></path>
      </mask>
      <g
        fill='color(display-p3 0.9373 0.8667 0.6235)'
        mask='url(#mask0_250_242)'
      >
        <path d='M3.15 14.757H7.343999999999999V24.139H3.15z'></path>
        <path d='M8.394 11.059H12.588000000000001V24.139H8.394z'></path>
        <path d='M13.637 7.03H17.831V24.139000000000003H13.637z'></path>
      </g>
    </svg>
  );
}

export default MKLogo;
